var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": "75px",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "app-main-inner-row",
                    staticStyle: { "padding-bottom": "0" }
                  },
                  [
                    _c("div", { staticStyle: { width: "1000px" } }, [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.applicationNo") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "170px" },
                                attrs: { no: "1", disabled: "disabled" },
                                model: {
                                  value: _vm.billPayment.billPaymentNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billPayment,
                                      "billPaymentNo",
                                      $$v
                                    )
                                  },
                                  expression: "billPayment.billPaymentNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.status"),
                                "label-width": "50px"
                              }
                            },
                            [
                              _vm.billPayment.state === 0
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_NoSubmit_SR")
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm.billPayment.state === 1 ||
                              _vm.billPayment.state === 2
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_AwaitApproval_SR"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm.billPayment.state === 3
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Approved_SR")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.settleAccountsTo")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "2",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { customer: true },
                                  "default-value":
                                    Number(_vm.billPayment.accountId) || "",
                                  "tag-name": "chineseName",
                                  disabled: ""
                                },
                                on: {
                                  parentCallBack: _vm.billPaymentAccountCallBack
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    no: "3",
                                    disabled: _vm.canEditAgent,
                                    "true-label": "1",
                                    "false-label": "0"
                                  },
                                  on: {
                                    change: _vm.cbSettlementAgentChangeHandler
                                  },
                                  model: {
                                    value: _vm.agentChecked,
                                    callback: function($$v) {
                                      _vm.agentChecked = $$v
                                    },
                                    expression: "agentChecked"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Payment.bySettlementAgent"))
                                  )
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "170px"
                                  },
                                  attrs: {
                                    no: "4",
                                    disabled: _vm.canEditAgentBox
                                  },
                                  on: {
                                    change: _vm.ddlSettlementAgentChangeHandler
                                  },
                                  model: {
                                    value: _vm.billPayment.settlementAgentId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billPayment,
                                        "settlementAgentId",
                                        $$v
                                      )
                                    },
                                    expression: "billPayment.settlementAgentId"
                                  }
                                },
                                _vm._l(_vm.settlementAgentList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label:
                                        _vm.$store.getters.language === "zh"
                                          ? item.chineseName
                                          : item.englishName,
                                      value: Number(item.cmpIdx) || ""
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.businessType") }
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  attrs: { no: "5", disabled: "" },
                                  model: {
                                    value: _vm.ywTypeList,
                                    callback: function($$v) {
                                      _vm.ywTypeList = $$v
                                    },
                                    expression: "ywTypeList"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    { attrs: { no: "6", label: "SE" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Payment.oceanExport"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { no: "7", label: "SI" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Payment.oceanImport"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { no: "8", label: "AE" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Payment.airExport"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    { attrs: { no: "9", label: "AI" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Payment.airImport"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Payment.currency") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  no: "10",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  "default-value":
                                    _vm.billPayment.currency || "",
                                  disabled: _vm.saveDisabled
                                },
                                on: { parentCallBack: _vm.currencyExchanged }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.rateTitle,
                                "label-width": "70px"
                              }
                            },
                            [
                              _c("num-input", {
                                staticStyle: { width: "130px" },
                                attrs: {
                                  no: "11",
                                  max: 999999999.0,
                                  min: 0.000001,
                                  precision: 8,
                                  "truncated-precision": _vm.ratePrecision,
                                  disabled: _vm.saveDisabled
                                },
                                on: { change: _vm.rateChangeHandler },
                                model: {
                                  value: _vm.billPayment.rate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billPayment, "rate", $$v)
                                  },
                                  expression: "billPayment.rate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.amount"),
                                "label-width": "40px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100px" },
                                attrs: { no: "12", disabled: "" },
                                model: {
                                  value: _vm.billPayment.amount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billPayment, "amount", $$v)
                                  },
                                  expression: "billPayment.amount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.paymentPeriod") }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "13",
                                  type: "date",
                                  clearable: "",
                                  disabled: _vm.saveDisabled
                                },
                                model: {
                                  value: _vm.billPayment.deadline,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billPayment, "deadline", $$v)
                                  },
                                  expression: "billPayment.deadline"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.methodOfPayment")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    no: "14",
                                    disabled: _vm.saveDisabled
                                  },
                                  model: {
                                    value: _vm.billPayment.payType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.billPayment, "payType", $$v)
                                    },
                                    expression: "billPayment.payType"
                                  }
                                },
                                _vm._l(_vm.receive_types, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label:
                                        _vm.$store.getters.language === "zh"
                                          ? item.chineseName
                                          : item.englishName,
                                      value: Number(item.code)
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.bankOfDeposit") }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  no: "15",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_TitleBank,
                                  "default-value": _vm.buyerBankUuid,
                                  cache: false,
                                  "static-options": _vm.titleBankArray,
                                  "tag-value": "uuid",
                                  "tag-name": "bank",
                                  headers: ["币种", "银行名称"],
                                  fields: ["currency", "bank"],
                                  disabled: _vm.saveDisabled
                                },
                                on: { parentCallBack: _vm.getBankCusFromChild }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Payment.bankAccount") } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: { no: "16", disabled: _vm.saveDisabled },
                                model: {
                                  value: _vm.billPayment.buyerBankAccount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billPayment,
                                      "buyerBankAccount",
                                      $$v
                                    )
                                  },
                                  expression: "billPayment.buyerBankAccount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Payment.applicant") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "17",
                                  "actionable-option": function(item) {
                                    return item.active
                                  },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_User,
                                  url: _vm.URL.sys.getUsersByPrivilegeDetail,
                                  cache: false,
                                  "method-params": {
                                    officeId: _vm.$store.getters.currentOfficeId
                                  },
                                  filterable: "",
                                  "default-value":
                                    Number(_vm.billPayment.inputBy) || "",
                                  disabled: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.billPayment.inputBy =
                                      item.chineseName)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Payment.dateOfApplication")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "18",
                                  type: "date",
                                  clearable: "",
                                  disabled: _vm.saveDisabled
                                },
                                model: {
                                  value: _vm.billPayment.inputDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billPayment, "inputDate", $$v)
                                  },
                                  expression: "billPayment.inputDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Payment.totalCurrency") }
                            },
                            [
                              _c("div", { staticStyle: { width: "150px" } }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.billPayment.currencyAmount))
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.openSapConfig,
                                  expression: "openSapConfig"
                                }
                              ],
                              attrs: {
                                label: _vm.$t("Payment.settleDepartmentPrefix")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "19",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_Department_All,
                                  "method-params": {
                                    officeUuid:
                                      _vm.$store.getters.currentOfficeUuid,
                                    clearing: true
                                  },
                                  filterable: "",
                                  "default-value":
                                    _vm.billPayment.settleDepartmentPrefix,
                                  "tag-name": "chineseName",
                                  "tag-value": "jobNoPrefix",
                                  disabled: _vm.saveDisabled
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.billPayment.settleDepartmentPrefix =
                                      item.jobNoPrefix)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticStyle: { width: "290px" } }, [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    color: "darkred",
                                    "font-size": "14px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Payment.couldNotSearhWriteOffJobFromThisWindow"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom-textarea",
                              attrs: {
                                label: _vm.$t("Payment.remarks"),
                                "label-width": "100px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "290px" },
                                attrs: { no: "20", type: "textarea", rows: 12 },
                                model: {
                                  value: _vm.billPayment.remark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billPayment, "remark", $$v)
                                  },
                                  expression: "billPayment.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "200px" },
              attrs: {
                slot: "left",
                "show-side-bar": false,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              slot: "left"
            })
          ],
          1
        ),
        _c("div", { staticClass: "section" }, [
          _vm.innerParamsFinal === 0
            ? _c(
                "span",
                { staticStyle: { position: "absolute" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "5px" },
                      attrs: { no: "21", type: "primary" },
                      on: { click: _vm.addCharge }
                    },
                    [_vm._v(_vm._s(_vm.$t("Payment.addCharge")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "22", type: "primary" },
                      on: { click: _vm.removeCahrge }
                    },
                    [_vm._v(_vm._s(_vm.$t("Payment.removeCharge")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            { staticStyle: { float: "right" } },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.innerParamsFinal === -1,
                      expression: "innerParamsFinal === -1"
                    }
                  ],
                  staticStyle: { "margin-right": "0" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "23", type: "primary" },
                      on: { click: _vm.toPreStep }
                    },
                    [_vm._v("上一步")]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", "margin-left": "5px" },
                  attrs: { no: "24" },
                  on: {
                    click: function($event) {
                      return _vm.cancel(0)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: {
                    no: "25",
                    type: "primary",
                    disabled: _vm.saveDisabled
                  },
                  on: { click: _vm.doSave }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.innerParamsFinal === 0,
                      expression: "innerParamsFinal === 0"
                    }
                  ],
                  staticStyle: { float: "right" },
                  attrs: {
                    no: "26",
                    disabled: _vm.canSendWeaver,
                    type: "primary"
                  },
                  on: { click: _vm.commit }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.sendWeaver")))]
              ),
              _vm.billPayment.uuid
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { no: "27", type: "primary" },
                      on: { click: _vm.toPrint }
                    },
                    [_vm._v(_vm._s(_vm.$t("Payment.print")))]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm.joinCharge.visible
        ? _c("join-charge-dialog", {
            attrs: {
              visible: _vm.joinCharge.visible,
              "default-conditions": _vm.joinCharge.addChargeCondition
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.joinCharge, "visible", $event)
              },
              leavePage: function($event) {
                return _vm.cancel(0)
              },
              addChargeCallBackEvent: _vm.addChargeCallBackEvent
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }